import { render, staticRenderFns } from "./lifeAtBest.vue?vue&type=template&id=4c48e5fc&scoped=true&"
import script from "./lifeAtBest.vue?vue&type=script&lang=js&"
export * from "./lifeAtBest.vue?vue&type=script&lang=js&"
import style0 from "./lifeAtBest.vue?vue&type=style&index=0&id=4c48e5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48e5fc",
  null
  
)

export default component.exports